var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.73 19.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,15.39,15.43,17V15.4ZM1.64,3.6h2.9V4.71a.82.82,0,1,0,1.64,0V3.6h7.36V4.71a.83.83,0,1,0,1.65,0V3.6h2.89V13.67H14.61a.77.77,0,0,0-.83.86V18H1.64ZM18.91,1.87H15.19v-1a.82.82,0,1,0-1.64,0v1H6.19v-1a.83.83,0,1,0-1.65,0v1H.82A.83.83,0,0,0,0,2.73V18.87a.84.84,0,0,0,.82.86h14a.81.81,0,0,0,.58-.25l4.08-4.31a.87.87,0,0,0,.24-.6V2.73a.84.84,0,0,0-.82-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.05,6.68H6.47a.85.85,0,0,0-.83.87.84.84,0,0,0,.83.86h.75v5.66a.83.83,0,1,0,1.65,0V7.54a.85.85,0,0,0-.82-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.48,6.68H10.9a.85.85,0,0,0-.83.87.84.84,0,0,0,.83.86h.75v5.66a.83.83,0,1,0,1.65,0V7.54a.85.85,0,0,0-.82-.86Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.a6628ce3762d55afdea0a2c5c8ebcce3.svg";
export { ForwardRef as ReactComponent };